import { useEffect, useState } from "react";
import { fetchMedia, fetchMediaPlaybackUrl, type MediaItem } from "./media";

export function MemberChannel() {
  const [items, setItems] = useState<MediaItem[]>([]);
  const [active, setActive] = useState<MediaItem | null>(null);
  const [playbackUrl, setPlaybackUrl] = useState<string | null>(null);
  const [status, setStatus] = useState("Tuning the channel…");

  useEffect(() => {
    void fetchMedia()
      .then((media) => {
        setItems(media);
        setStatus(media.length === 0 ? "The channel is off-air. Check back after the first upload." : "");
      })
      .catch((error: unknown) => setStatus(error instanceof Error ? error.message : "Could not tune the channel"));
  }, []);

  async function play(item: MediaItem) {
    setActive(item);
    setPlaybackUrl(null);
    setStatus("Loading broadcast…");
    try {
      setPlaybackUrl(await fetchMediaPlaybackUrl(item));
      setStatus("");
    } catch (error) {
      setStatus(error instanceof Error ? error.message : "Could not load broadcast");
    }
  }

  return (
    <main className="channel" data-testid="member-channel">
      <p className="eyebrow">Channel 02 · Now available</p>
      <h1>Cat TV</h1>
      <p className="lede">Real memories first. Stranger dreams later.</p>

      {status && <p className="channel-status" role="status">{status}</p>}
      {active && playbackUrl && (
        <figure className="player">
          {active.content_type.startsWith("video/") ? (
            <video src={playbackUrl} controls autoPlay playsInline />
          ) : (
            <img src={playbackUrl} alt={active.title} />
          )}
          <figcaption>{active.title}</figcaption>
        </figure>
      )}

      <section className="program-grid" aria-label="Cat TV programs">
        {items.map((item, index) => (
          <button key={item.id} onClick={() => void play(item)}>
            <span>{String(index + 1).padStart(2, "0")}</span>
            <strong>{item.title}</strong>
            <small>
              {item.channel_kind === "dream"
                ? "Dream"
                : item.content_type.startsWith("video/") ? "Movie" : "Photo"}
            </small>
          </button>
        ))}
      </section>
    </main>
  );
}
